export default "__VITE_ASSET__Bvam_v8v__"